var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.833h-3v-1.666h3v1.666zm2.21-3.363l2.33 2.587-3.084.776.754-3.363zM18 7.604l-5.924 6.663L9.675 11.6l5.923-6.662L18 7.604zm-4.5 7.433v3.296h-12V1.667h5.521c3.118 0 1.979 5 1.979 5s1.735-.53 3.05-.111l1.464-1.647C11.854 2.57 9.193 0 7.642 0H0v20h15v-6.65l-1.5 1.688z",
    fill: "#292929",
    fillRule: "evenodd"
  })));
}
export default SvgIconEdit;